import { isCurrentBroadcastCard } from '../../utils/cardProgress';
import { isPosterList, isSquareList } from '../../utils/list';
import { CardWithPointer } from '../../../store/view/types';
import { getCurrentTransmission } from '../utils';
import { CardList } from '../viewTypes';
import { isDetailsCard } from './presentation';
import { Image } from '@yleisradio/areena-types';

type GetImageParams = {
  cardList: CardList;
  card: CardWithPointer;
};

export const getCardListImage = ({ cardList, card }: GetImageParams) => {
  const listStyle = cardList.style;
  if (
    isCurrentBroadcastCard(card) &&
    !isPosterList(listStyle) &&
    !isSquareList(listStyle)
  ) {
    return getCurrentTransmission(card.transmissions)?.image;
  }
  return card.image;
};

type LimelightImages = {
  logo?: Image | undefined;
  image?: Image | undefined;
};

export const getLimelightImages = ({
  card,
  cardList,
}: GetImageParams): LimelightImages => {
  const detailsCard = card.cards?.find(c => isDetailsCard(c.presentation));
  const logo = detailsCard?.overlayLogoImage;
  const currentTransmission = getCurrentTransmission(card.transmissions);
  if (isSquareList(cardList.style) && currentTransmission?.image) {
    return {
      logo,
      image: currentTransmission.image,
    };
  }

  return {
    logo,
    image: detailsCard?.image ?? card.image,
  };
};
